<template>
  <div>
    <div
      v-if="submit_loader"
      style="
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding-top: 25%;
        background-color: rgba(255, 255, 255, 0.31);
      "
    >
      <div class="text-xs-center" large></div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 sm8 md8 class="text-xs-left">
          <!-- <h2>Create Workspace</h2> -->
        </v-flex>
      </v-layout>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-card>
          <!--   <v-flex xs12 class="text-xs-right" mt-1>
              <v-menu offset-y>
                <v-btn
                  slot="activator"
                  color="rgb(248 71 6)"
                  class="white--text list_notification"
                  @click="backtonotification()"
                >
                  <v-icon color="#bbbbc6" class="white--text mr-2"
                    >arrow_back</v-icon
                  >
                  back
                </v-btn>
              </v-menu>
            </v-flex> -->
            <v-form
              id="create_notification"
              @submit.prevent="validateBeforeSubmit('createNotification')"
              data-vv-scope="createNotification"
              v-model="valid"
            >
              <v-card-text>
                <v-layout row wrap style="margin-bottom: 20px;">
                  <v-flex xs12 md12 lg8>
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>Notification Type :</label>
                    </v-flex>
                    <v-autocomplete
                        label="Select"
                        name="Type"
                        :items="notification_types"
                        v-model="notification_object.type"
                        return-object solo flat
                        item-text="name"
                        item-value="id"
                        v-validate="'required'"
                        :error-messages="errors.collect('createNotification.Type')"
                        clearable>
                    </v-autocomplete>
                  </v-flex>


                  <v-flex xs12 md12 lg12 style="display: flex">
                    <v-flex xs12 md8 lg4>
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>Topic :</label>
                    </v-flex>
                    <v-autocomplete
                        label="Topic"
                        name="Topic"
                        :items="topics"
                        item-text='text'
                        item-value='value'
                        v-model="notification_object.topic"
                        solo flat
                        v-validate="'required'"
                        :error-messages="errors.collect('createNotification.Topic')"
                        clearable>
                    </v-autocomplete>
                  </v-flex>


                    <v-flex xs12 md8 lg4>
                      <label>City Name</label>
                      <v-autocomplete
                          :items="cityList"
                          name="City Name"
                          label="Select City"
                          v-model="notification_object.city_id"
                          item-text="name"
                          item-value="id"
                          v-validate="'required'"
                          solo flat
                          :error-messages="errors.collect('createNotification.City Name')"
                      >
                      </v-autocomplete>
                    </v-flex>
                  </v-flex>


                  <v-flex xs12 md12 lg8 v-if="notification_object.topic == 'promotional_notifications'">
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>Event Name :<span class="red--text v-text-field__details v-messages theme--light"
                                      v-if="custom_errors.title">{{ custom_errors.event_name }}</span>
                      </label>
                    </v-flex>
                    <v-text-field
                        name="Event Name"
                        v-model="notification_object.event_name"
                        label="Event Name"
                        :error-messages="errors.collect('createNotification.event_name')"
                        clearable solo flat
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md12 lg8 row>
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>Schedule At :</label>
                    </v-flex>
                    <v-flex xs12 md12 lg12 style="display: flex; flex-wrap: wrap; padding:0px !important">
                      <v-flex xs12 md6 lg6>
                        <v-menu
                            ref="menu"
                            v-model="notification_object.menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="notification_object.date"
                                label="Select Date"
                                readonly
                                v-bind="attrs"
                                v-on="on" solo flat
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="notification_object.date"
                              no-title
                              scrollable
                              :min="this.current_date"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="notification_object.date = null"
                            >
                              Clear
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="notification_object.menu = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.menu.save(date)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-flex>

                      <v-flex xs12 md6 lg6>
                        <v-menu
                            ref="menu2"
                            v-model="notification_object.menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="time"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="notification_object.time"
                                label="Select Time"
                                readonly
                                v-bind="attrs"
                                v-on="on" solo flat
                            ></v-text-field>
                          </template>
                          <v-time-picker
                              v-if="notification_object.menu2"
                              v-model="notification_object.time"
                              full-width
                              use-seconds
                              @click:minute:seconds="$refs.menu2.save(time)"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="notification_object.time = null"
                            >
                              Clear
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="notification_object.menu2 = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.menu2.save(time)"
                            >
                              OK
                            </v-btn>
                          </v-time-picker>
                        </v-menu>
                      </v-flex>
                    </v-flex>
                  </v-flex>


<!--                  <v-flex xs12 md12 lg8>-->
<!--                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">-->
<!--                      <label>Status :</label>-->
<!--                    </v-flex>-->
<!--                    <v-autocomplete-->
<!--                        label="Status"-->
<!--                        v-model="value"-->
<!--                        :items="notification_object.status"-->
<!--                        dense-->
<!--                        filled solo flat-->
<!--                    >-->
<!--                    </v-autocomplete>-->
<!--                  </v-flex>-->

                  <v-flex xs12 md12 lg8 style="margin-left: 10px; padding-bottom: 23px !important;"
                          v-if="notification_object.topic != 'promotional_notifications'">
                      <v-checkbox
                          v-model="notification_object.is_user_specific"
                          label="Add Custom users name into notification"></v-checkbox>

                      <span style="color: red" v-if="notification_object.is_user_specific == 1">
                      The placeholder {user_name} will automatically replaced with user names.
                    </span>
                  </v-flex>

                  <v-flex xs12 md12 lg8>
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>Title :<span class="red--text v-text-field__details v-messages theme--light" v-if="custom_errors.title">{{ custom_errors.title }}</span>
                      </label>
                    </v-flex>
                    <v-text-field
                        name="Title"
                        v-model="notification_object.title"
                        label="Title"
                        :error-messages="errors.collect('createNotification.Title')"
                        clearable solo flat
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md12 lg8>
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>Body :<span class="red--text v-text-field__details v-messages theme--light" v-if="custom_errors.body">{{ custom_errors.body }}</span></label>
                    </v-flex>
                    <v-textarea
                        name="Body"
                        v-model="notification_object.body"
                        label="Body"
                        rows="2"
                        :error-messages="errors.collect('createNotification.Body')"
                        clearable solo flat
                    ></v-textarea>
                  </v-flex>


                  <v-flex xs12 md12 lg8>
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>External Link :</label>
                    </v-flex>
                    <v-text-field
                        name="url"
                        v-model="notification_object.link_url"
                        label="External Link"
                        clearable solo flat
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 md8 lg8 style="display: flex; flex-wrap: wrap; padding-bottom: 23px !important;">
                    <v-flex xs12 sm6 md6 lg5 style="padding-bottom: 15px !important;">
                      <label>Upload Image</label>
                      <input type="file" name="previewImage" class="form-control flatpickerCSS2" id="previewImage"
                             accept="*/*"
                             @change=uploadImage
                             v-validate="'ext:jpg,jpeg,png'" /><br>
                      <span style="font-size: 11px;">(Allowed file types: jpg,jpeg,png)</span>
                      <div class="red--text pt-3" v-if="errors.collect('createNotification.previewImage').length">
                        {{ errors.collect('createNotification.previewImage')[0] }}
                      </div>
                    </v-flex>

                    <v-flex xs12 sm6 md6 lg3 class="ImageDisplay" v-if="notification_object.previewImage !== ''"
                            style="flex-wrap: wrap; flex-direction: column; align-items:center; justify-content: space-around; align-content: space-around;">
                      <v-flex xs12 sm12 md12 lg12
                              style="height: auto; width: auto; align-content: center;">
                        <div v-if="notification_object.previewImage" class="mt-3">
                          <img :src="notification_object.previewImage" class="figure-img img-fluid rounded"
                               style="max-height:100px;">
                        </div>
                      </v-flex>

                      <v-flex xs12 sm12 md12 lg12>
                        <v-btn icon @click="clearImage()">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-flex>

                  </v-flex>

                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small :disabled="!valid || notification_object.type == '' ||
                notification_object.topic == '' || custom_errors.body != ''
                ||custom_errors.title != ''"
                       type="submit">create
                </v-btn>
                <v-btn flat small to="/notifications">Cancel</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
      <v-snackbar
        :color="snackBar.color"
        :top="snackBar.top"
        :bottom="snackBar.bottom"
        :left="snackBar.left"
        :right="snackBar.right"
        v-model="snackBar.show"
      >
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>



<script>
import moment from "moment";
import { VueEditor } from "vue2-editor";
import axios from 'axios'

export default {
  name: "Create",
  components: {
    VueEditor,
  },
  watch: {
    "notification_object.type":function(val){
      if(val.key == 'open_adgebra_ad' || val.key == 'open_adgebra_ad_ios' ||
          val.key == 'open_mgid_ad_ios' || val.key == 'open_mgid_ad'){
        if(true){
          if(val.key == 'open_adgebra_ad_ios' || val.key == 'open_mgid_ad_ios'){
            this.topics = {'text' : "Non-VIP IOS User Notifications", 'value':"non_vip_user_ios"};
          }else if(val.key == 'open_adgebra_ad' || val.key == 'open_mgid_ad'){
              this.topics = {'text' : "Non-VIP User Notifications", 'value':"non_vip_user"};
        }
          this.notification_object.title = null;
          this.notification_object.body = null;
          this.custom_errors.title = '';
          this.custom_errors.body = '';
          if(this.notification_object.title == null){
            this.custom_errors.title = '';
          }
        }
      }else{
        this.topics = [
          {'text':"All", 'value':"All"},
          {'text' : "Personalised Notifications", 'value':"personalised_notifications"},
          {'text' : "Promotional Notifications", 'value':"promotional_notifications"}];
        if(this.notification_object.title == null){
          this.custom_errors.title = 'Title is required.';
        }
        if(this.notification_object.body == null){
          this.custom_errors.body = 'Body is required.';
        }
      }
    },
    "notification_object.is_user_specific": function (val) {
      if(val == true){
        this.notification_object.title = "{user_name}"
      }else if(val == false){
        if(this.notification_object.title != null){
          this.notification_object.title = this.notification_object.title.replace("{user_name}", "");
        }
      }
    },
    "notification_object.title": function (val){
      if(val == null){
        if(this.notification_object.type.key != 'open_adgebra_ad' || this.notification_object.type.key !=
            'open_adgebra_ad_ios' || this.notification_object.type.key != 'open_mgid_ad'){
          this.custom_errors.title = 'Title is required.';
        }else{
          this.custom_errors.title = '';
        }
        this.notification_object.is_user_specific = false;
      }else{
        this.custom_errors.title = '';
      }
    },
    "notification_object.body": function (val){
      if(val == null){
        this.custom_errors.body = '';
        if(this.notification_object.type.key != 'open_adgebra_ad' ||
            this.notification_object.type.key != 'open_adgebra_ad_ios'
            || this.notification_object.type.key != 'open_mgid_ad'){
          this.custom_errors.body = 'Body is required.';
        }
      }else{
        this.custom_errors.body = '';
      }
    }
  },
  data: () => {
    return {
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      },
      notification_object: {
        title: null,
        type: "",
        topic: '',
        link_url: "",
        body: null,
        date: "",
        menu: false,
        modal: false,
        time: null,
        menu2: false,
        modal2: false,
        previewImage: '',
        is_user_specific: 0,
        event_name: ''
      },
      image: "",
      previewImage:null,
      notification_types:[],
      notification_ID: null,
      submit_loader: false,
      valid: false,
      types: ["Advertisement", "General"],
      topics: [
          {'text':"All", 'value':"All"},
          {'text' : "Personalised Notifications", 'value':"personalised_notifications"},
          {'text' : "Promotional Notifications", 'value':"promotional_notifications"}],
      snackBar: {
        show: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false,
      },
      time: null,
      date: null,
      current_date:"",
      custom_errors: {
        title: '',
        body: ''
      },
      cityList: [],
    };
  },

  methods: {
    // selectImage () {
    //       this.$refs.fileInput.click()
    //   },
    uploadImage(e){
        const image_path = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(image_path);
        reader.onload = e =>{
          this.notification_object.previewImage = e.target.result;
          // console.log(this.previewImage);
        };
    },
    backtonotification:function(){
        this.$router.push({name:"Notifications"});
    },
    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this[scope]();
        }
      });
    },
     getTypeList:function()
        {
        axios
            .get(`${process.env.VUE_APP_API_URL}/api/v1/notification-types`,{headers:this.$headers})
            .then(response => {
              if (response.data.status == 1)
              { 
                
                this.notification_types = response.data.types;
                  
              }
             
            })
        },
    createNotification: function () {
      this.submit_loader = true;
      let new_notification = Object.assign({}, this.notification_object);
      new_notification.title = this.notification_object.title;
      new_notification.type = this.notification_object.type.key;
      new_notification.link_url = this.notification_object.link_url;
      new_notification.topic = this.notification_object.topic;
      new_notification.body = this.notification_object.body;
      new_notification.date = this.notification_object.date;
      new_notification.time = this.notification_object.time;
      new_notification.is_user_specific = this.notification_object.is_user_specific;
      new_notification.event_name = this.notification_object.event_name;
      new_notification.city_id = this.notification_object.city_id;
      // if (this.previewImage == "") {
      //   new_notification.previewImage = "";
      // } else {
      //   // new_notification.image = this.image[0].name;
      //    new_notification.previewImage = this.previewImage;
      //
      // }

      axios
        .post(
          `${process.env.VUE_APP_API_URL}/api/v1/storeNotification`,
          new_notification,
          { headers: this.$headers }
        )
        .then((response) => {
          if (response.data.status == 1) {
            // console.log(response.data.notification_id);
            this.notification_ID = response.data.notification_id.id;
            this.$router.push({
              name: "notification",
              params: { id: this.notification_ID },
            });
            this.snackBar.message = response.data.message;
            this.submit_loader = false;
          } else {
            this.snackBar.message = response.data.message;
            this.snackBar.show = true;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.submit_loader = false;
        });
    },
    clearImage(){
      this.notification_object.previewImage = '';
      this.previewImage = '';
      $('#image_path').val('');
      const index = this.errors.items.findIndex(item => item.field == 'previewImage');
      if (index !== -1) {
        this.errors.items.splice(index, 1);
      }
    },
    getCityList(){
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/get-city-list`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.cityList = response.data.data;
              this.cityList.push({'id' : 0, 'name':"ALL"})
            }
          });
    }
  },
    mounted(){
      this.getCityList();
      this.getTypeList();
      this.notification_object.date = null;
      this.current_date = moment().format('YYYY-MM-DD'); // September 11th 2019, 10:52:10 am
    },
};
</script>

<!-- <style type="text/css">
  .imagePreviewWrapper {
   width: 280px;
    height: 280px;
    display: block;
    cursor: pointer;
    margin: auto -6px;
    background-size: cover;
    background-position: center center;
} 
</style> -->


